import { render, staticRenderFns } from "./SocialIconList.vue?vue&type=template&id=abfa3ba0&scoped=true"
import script from "./SocialIconList.vue?vue&type=script&lang=js"
export * from "./SocialIconList.vue?vue&type=script&lang=js"
import style0 from "./SocialIconList.vue?vue&type=style&index=0&id=abfa3ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfa3ba0",
  null
  
)

export default component.exports